import { createRoot } from "react-dom/client";
import { useEffect, useState } from "react";

import App from "./App";
import AppMobile from "./AppMobile";

/* Viewport switch: <=768px wide renders the mobile app (AppMobile.js), otherwise the desktop app (App.js).
   PARITY NOTE: see CLAUDE.md — all content/features must exist in BOTH versions. */
const MOBILE_QUERY = "(max-width: 768px)";

function Root() {
  const [isMobile, setIsMobile] = useState(window.matchMedia(MOBILE_QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return isMobile ? <AppMobile /> : <App />;
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(<Root />);
